interface TabProps {
  tab: string | React.ReactNode;
  keynumber: number;
  className?: string;
  onClick?: () => void;
}

const Tab: React.FC<TabProps> = ({ tab, keynumber, className, onClick }) => {
  return (
    <span
      onClick={onClick}
      className={
        "flex gap-5 w-fit justify-center items-center bg-primary font-normal cursor-pointer py-2 hover:text-primary" +
        className
      }
      key={keynumber}
    >
      {tab}
    </span>
  );
};
export default Tab;
